import {
    Box,
    Button,
    Flex,
    Heading,
    Icon,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Text,
    useBreakpointValue,
  } from "@chakra-ui/react";
  import { BsFillCheckSquareFill } from "react-icons/bs";
  import { ImWhatsapp } from "react-icons/im";
  import { Header } from "../../components/Header";
  import { Sidebar } from "../../components/Sidebar";
  import { Pagination } from "../../components/Pagination";
  import { Link } from "react-router-dom";
  
  export default function Request() {
    const isWideVersion = useBreakpointValue({
      base: false,
      lg: true,
    });

    const isMdVersion = useBreakpointValue({
      base: false,
      md: true,
    });

    const isSmVersion = useBreakpointValue({
      base: false,
      sm: true,
    });
    return (
      <Flex direction="column" h="100vh" bg="bg">
        <Header />
  
        <Flex w="100%" maxWidth={1460} px={isMdVersion ? "10" : "3"} >
          <Sidebar />
  
          <Box overflowX="auto" flex="1" borderRadius={8} bg="gray" p="6">
            {isWideVersion && (
              <Flex mb="8" justify="space-between" align="center">
                <Heading fontSize='21'  fontWeight="400" color="text">
                  Solicitação de serviço
                </Heading>
              </Flex>
            )}
  
            <Table colorScheme="whiteAlpha" >
              <Thead>
                <Tr color="gray_light" >
                  <Th fontWeight="600" fontSize='13' px="1" py="3">Nome</Th>
                  {isWideVersion && <Th fontWeight="600" fontSize='13' px="1" py="3">Data da solicitação</Th>}
                  {isSmVersion &&  <Th fontWeight="600" fontSize='13' px="1" py="3">Serviço</Th>}
                  <Th fontWeight="600" fontSize='13' px="1" py="3">Contato</Th>
                  <Th width="8" px="1" py="3"></Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td px="1" py="3">
                    <Box>
                      <Text color="text">Nome</Text>
                    </Box>
                  </Td>
                  {isWideVersion && <Td color="white" px="1" py="3">10/04/2022</Td>}
                  {isSmVersion &&  <Td color="white" px="1" py="3">Seguro</Td>}
                  <Td px="1" py="3">
                    <Button
                      as="a"
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      cursor="pointer"
                    >
                      <Icon as={ImWhatsapp} fontSize="16" />
                    </Button>
                  </Td>
                  <Td px="1" py="3">
                    <Button
                      as="a"
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      cursor="pointer"
                    >
                      <Icon as={BsFillCheckSquareFill} color="green.400" fontSize="20" />
                    </Button>
                  </Td>
                </Tr>

                <Tr>
                  <Td px="1" py="3">
                    <Box>
                      <Text color="text">Nome</Text>
                    </Box>
                  </Td>
                  {isWideVersion && <Td color="white" px="1" py="3">10/04/2022</Td>}
                  {isSmVersion &&  <Td color="white" px="1" py="3">Seguro</Td>}
                  <Td px="1" py="3">
                    <Button
                      as="a"
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      cursor="pointer"
                    >
                      <Icon as={ImWhatsapp} fontSize="16" />
                    </Button>
                  </Td>
                  <Td px="1" py="3">
                    <Button
                      as="a"
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      cursor="pointer"
                    >
                      <Icon as={BsFillCheckSquareFill} color="green.400" fontSize="20" />
                    </Button>
                  </Td>
                </Tr>

                <Tr>
                  <Td px="1" py="3">
                    <Box>
                      <Text color="text">Nome</Text>
                    </Box>
                  </Td>
                  {isWideVersion && <Td color="white" px="1" py="3">10/04/2022</Td>}
                  {isSmVersion &&  <Td color="white" px="1" py="3">Seguro</Td>}
                  <Td px="1" py="3">
                    <Button
                      as="a"
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      cursor="pointer"
                    >
                      <Icon as={ImWhatsapp} fontSize="16" />
                    </Button>
                  </Td>
                  <Td px="1" py="3">
                    <Button
                      as="a"
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      cursor="pointer"
                    >
                      <Icon as={BsFillCheckSquareFill} color="green.400" fontSize="20" />
                    </Button>
                  </Td>
                </Tr>
              </Tbody>
            </Table>
            <Pagination total={0} totalPerPage={10} onChange={() => {}} />
          </Box>
        </Flex>
      </Flex>
    );
  }
  